import { render, staticRenderFns } from "./TaskPhotosList.vue?vue&type=template&id=624ed146&"
import script from "./TaskPhotosList.vue?vue&type=script&lang=ts&"
export * from "./TaskPhotosList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports